import axios from 'axios';

let urlApi = "/";

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
	urlApi = `${window.location.protocol}//localhost:3000/`;
}

const AxiosCaller = axios.create({
	baseURL: urlApi,
	withCredentials: true,
	headers: { 'api': 'true' },
});

AxiosCaller.interceptors.response.use(function (response) {
	return Promise.resolve(response);
}, error => {
	if (error.response && error.response.status === 401) {
		window.location.pathname = '/';
	} else {
		return Promise.resolve(error);
	}

});


export default AxiosCaller;